import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import Config from '../../../utils/Config';
import styles from './GoogleAuth.module.css';
import googleGLogo from '../../../assets/icons/google-g-logo.svg';

const GoogleAuth = (props) => {

  const { onLogin, requiredScopes = [], icon, variant = 'legacy' } = props;

  const login = useGoogleLogin({
      onSuccess: async (code) => {
        
        var gtkn = code["code"]
        if ( gtkn != null) {
          
          axios.post(Config.BASE_URL + '/auth/google', 
              {
                "gcode" : gtkn
              },
            {
              headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            },
          ).then(responseJSON => {
            onLogin()
          }).catch(err => {
            console.log(err);
          });
        }
      },
      flow: 'auth-code',
      scope: requiredScopes.length > 0 ? requiredScopes.join(' ') : undefined,
      onError: (error) => console.log('Login Failed:', error)
  });

  return (
    <>
        <button className={styles.gsiMaterialButton} onClick={() => login()}>
          <span className={styles.gsiMaterialButtonState} aria-hidden="true" />
          <span className={styles.gsiMaterialButtonContentWrapper}>
            <span className={styles.gsiMaterialButtonIcon}>
              <img src={googleGLogo} alt="" />
            </span>
            <span className={styles.gsiMaterialButtonContents}>Sign in with Google</span>
          </span>
        </button>
    </>
  )
}

export default GoogleAuth;